import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobsGet = {
    path: "/jobs",
    method: RouteHttpVerb.GET
};
export { locationRestJobsGet };
